export function ThumbUpFillIcon({ size, color = "black", className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={size}
      width={size}
      className={className}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m7.24 11v9h-1.61c-.9 0-1.62-.72-1.62-1.61v-5.77c0-.89.73-1.62 1.62-1.62zm11.26-1.5h-4.78v-3.5c0-1.1-.9-2-1.99-2h-.09c-.4 0-.76.24-.92.61l-2.73 6.39v9s9.2 0 9.2 0c.73 0 1.35-.52 1.48-1.24l1.32-7.5c.16-.92-.54-1.76-1.48-1.76z" />
    </svg>
  );
}
